<template>
  <div class="col-md-3 mb-sm-3 mb-md-0">
    <b-list-group role="tablist" class="shadow bg-white h-100 p-b rounded-0">
      <b-list-group-item
        @click="
          page = 'familias_cadastradas';
          setTipo(page);
        "
        :class="page == 'familias_cadastradas' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        <svg
          style="width: 24px; height: 24px"
          :class="
            page == 'familias_cadastradas' ? 'text-white' : 'text-primary'
          "
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M12,3L2,12H5V20H19V12H22L12,3M11,10H13V13H16V15H13V18H11V15H8V13H11V10Z"
          />
        </svg>
        Famílias Cadastradas com geolocalização
      </b-list-group-item>
      <template v-if="$store.state.user.role_details.name != 'Nível Básico'">
        <b-list-group-item
          @click="
            page = 'familias_acompanhamento';
            setTipo(page);
          "
          :class="page == 'familias_acompanhamento' ? 'active' : ''"
          class="nav-link"
          href="#"
          role="tab"
        >
          <svg
            style="width: 24px; height: 24px"
            :class="
              page == 'familias_acompanhamento' ? 'text-white' : 'text-primary'
            "
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M3.69 9.12C3.5 8.93 3.29 8.84 3.04 8.84C2.63 8.84 2.32 9.03 2.12 9.42S1.97 10.18 2.29 10.53C3.47 11.59 4.22 12.34 4.54 12.78C4.95 13.34 5.15 14.16 5.15 15.22C5.15 16.53 5.65 17.5 6.65 18.17C7.21 18.61 7.82 18.94 8.5 19.16L8.5 15.27C8.5 14.33 8.17 13.55 7.54 12.92M16.46 12.97C15.84 13.59 15.5 14.36 15.5 15.27L15.5 19.2C16.46 18.86 17.26 18.33 17.92 17.63C18.57 16.93 18.9 16.16 18.9 15.22C18.9 14.09 19.09 13.28 19.47 12.78C19.56 12.62 19.73 12.42 20 12.17C20.23 11.92 20.47 11.68 20.71 11.46C20.94 11.25 21.17 11.03 21.39 10.81L21.72 10.53C21.91 10.34 22 10.12 22 9.87C22 9.59 21.91 9.34 21.72 9.14C21.53 8.94 21.3 8.84 21 8.84S20.5 8.93 20.31 9.12M12 20C12.69 20 13.36 19.91 14 19.72L14 16.15C14 15.56 13.82 15.1 13.41 14.66C13 14.22 12.53 14 12 14C11.47 14 11 14.2 10.62 14.61C10.22 15 10 15.46 10 16.06L10 19.72C10.64 19.91 11.31 20 12 20M9 8.5C9 9.33 8.33 10 7.5 10S6 9.33 6 8.5 6.67 7 7.5 7 9 7.67 9 8.5M18 8.5C18 9.33 17.33 10 16.5 10C15.67 10 15 9.33 15 8.5S15.67 7 16.5 7C17.33 7 18 7.67 18 8.5M13.5 5.5C13.5 6.33 12.83 7 12 7S10.5 6.33 10.5 5.5 11.17 4 12 4 13.5 4.67 13.5 5.5M13.5 11C13.5 11.83 12.83 12.5 12 12.5S10.5 11.83 10.5 11 11.17 9.5 12 9.5 13.5 10.17 13.5 11Z"
            />
          </svg>
          Família em Acompanhamento
        </b-list-group-item>
        <b-list-group-item
          @click="
            page = 'familias_atendidas';
            setTipo(page);
          "
          :class="page == 'familias_atendidas' ? 'active' : ''"
          class="nav-link"
          href="#"
          role="tab"
        >
          <svg
            style="width: 24px; height: 24px"
            :class="page == 'familias_atendidas' ? 'text-white' : 'text-primary'"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M20,12V16C20,17.11 19.11,18 18,18H13.9L10.2,21.71C10,21.89 9.76,22 9.5,22H9A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V6C2,4.89 2.9,4 4,4H9.5C8.95,4.67 8.5,5.42 8.14,6.25L7.85,7L8.14,7.75C9.43,10.94 12.5,13 16,13C17.44,13 18.8,12.63 20,12M16,6C16.56,6 17,6.44 17,7C17,7.56 16.56,8 16,8C15.44,8 15,7.56 15,7C15,6.44 15.44,6 16,6M16,3C18.73,3 21.06,4.66 22,7C21.06,9.34 18.73,11 16,11C13.27,11 10.94,9.34 10,7C10.94,4.66 13.27,3 16,3M16,4.5A2.5,2.5 0 0,0 13.5,7A2.5,2.5 0 0,0 16,9.5A2.5,2.5 0 0,0 18.5,7A2.5,2.5 0 0,0 16,4.5"
            />
          </svg>
          Famílias Atendidas
        </b-list-group-item>
        <b-list-group-item
          @click="
            page = 'programas';
            setTipo(page);
          "
          :class="page == 'programas' ? 'active' : ''"
          class="nav-link"
          href="#"
          role="tab"
        >
          <svg
            style="width: 24px; height: 24px"
            :class="page == 'programas' ? 'text-white' : 'text-success'"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M12.75,3.94C13.75,3.22 14.91,2.86 16.22,2.86C16.94,2.86 17.73,3.05 18.59,3.45C19.45,3.84 20.13,4.3 20.63,4.83C21.66,6.11 22.09,7.6 21.94,9.3C21.78,11 21.22,12.33 20.25,13.27L12.66,20.86C12.47,21.05 12.23,21.14 11.95,21.14C11.67,21.14 11.44,21.05 11.25,20.86C11.06,20.67 10.97,20.44 10.97,20.16C10.97,19.88 11.06,19.64 11.25,19.45L15.84,14.86C16.09,14.64 16.09,14.41 15.84,14.16C15.59,13.91 15.36,13.91 15.14,14.16L10.55,18.75C10.36,18.94 10.13,19.03 9.84,19.03C9.56,19.03 9.33,18.94 9.14,18.75C8.95,18.56 8.86,18.33 8.86,18.05C8.86,17.77 8.95,17.53 9.14,17.34L13.73,12.75C14,12.5 14,12.25 13.73,12C13.5,11.75 13.28,11.75 13.03,12L8.44,16.64C8.25,16.83 8,16.92 7.73,16.92C7.45,16.92 7.21,16.83 7,16.64C6.8,16.45 6.7,16.22 6.7,15.94C6.7,15.66 6.81,15.41 7.03,15.19L11.63,10.59C11.88,10.34 11.88,10.11 11.63,9.89C11.38,9.67 11.14,9.67 10.92,9.89L6.28,14.5C6.06,14.7 5.83,14.81 5.58,14.81C5.3,14.81 5.06,14.71 4.88,14.5C4.69,14.3 4.59,14.06 4.59,13.78C4.59,13.5 4.69,13.27 4.88,13.08C7.94,10 9.83,8.14 10.55,7.45L14.11,10.97C14.5,11.34 14.95,11.53 15.5,11.53C16.2,11.53 16.75,11.25 17.16,10.69C17.44,10.28 17.54,9.83 17.46,9.33C17.38,8.83 17.17,8.41 16.83,8.06L12.75,3.94M14.81,10.27L10.55,6L3.47,13.08C2.63,12.23 2.15,10.93 2.04,9.16C1.93,7.4 2.41,5.87 3.47,4.59C4.66,3.41 6.08,2.81 7.73,2.81C9.39,2.81 10.8,3.41 11.95,4.59L16.22,8.86C16.41,9.05 16.5,9.28 16.5,9.56C16.5,9.84 16.41,10.08 16.22,10.27C16.03,10.45 15.8,10.55 15.5,10.55C15.23,10.55 15,10.45 14.81,10.27V10.27Z"
            />
          </svg>
          Programas Sociais
        </b-list-group-item>
        <b-list-group-item
          @click="
            page = 'situacao_violacao';
            setTipo(page);
          "
          :class="page == 'situacao_violacao' ? 'active' : ''"
          class="nav-link"
          href="#"
          role="tab"
        >
          <svg
            style="width: 24px; height: 24px"
            :class="page == 'situacao_violacao' ? 'text-white' : 'text-danger'"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12M13,17H11V15H13V17M13,13H11V7H13V13Z"
            />
          </svg>
          Situação de Violação
        </b-list-group-item>
        <b-list-group-item
          @click="
            page = 'vulnerabilidades';
            setTipo(page);
          "
          :class="page == 'vulnerabilidades' ? 'active' : ''"
          class="nav-link"
          href="#"
          role="tab"
        >
          <svg
            style="width: 24px; height: 24px"
            :class="page == 'vulnerabilidades' ? 'text-white' : 'text-warning'"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
            />
          </svg>
          Vulnerabilidades
        </b-list-group-item>
        <b-list-group-item
          @click="
            page = 'faixa_etaria';
            setTipo(page);
          "
          :class="page == 'faixa_etaria' ? 'active' : ''"
          class="nav-link"
          href="#"
          role="tab"
        >
          <svg
            style="width: 24px; height: 24px"
            :class="page == 'faixa_etaria' ? 'text-white' : 'text-primary'"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M19.07,4.93C17.22,3 14.66,1.96 12,2C9.34,1.96 6.79,3 4.94,4.93C3,6.78 1.96,9.34 2,12C1.96,14.66 3,17.21 4.93,19.06C6.78,21 9.34,22.04 12,22C14.66,22.04 17.21,21 19.06,19.07C21,17.22 22.04,14.66 22,12C22.04,9.34 21,6.78 19.07,4.93M17,12V18H13.5V13H10.5V18H7V12H5L12,5L19.5,12H17Z"
            />
          </svg>
          Famílias por Faixa Etária
        </b-list-group-item>
      </template>
      <!-- <b-list-group-item
                @click="
                    page = 'bi';
                    setTipo(page);
                "
                :class="page == 'faixa_etaria' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                BI
            </b-list-group-item> -->
    </b-list-group>
  </div>
</template>
<script>
  export default {
    props: ["active"],
    data() {
      return {
        page: "familias_cadastradas",
        url: window.urlbase,
      };
    },
    mounted() {
      if (this.active) {
        this.page = this.active;
      }
      this.setTipo(this.page);
    },
    methods: {
      setTipo(tipo) {
        if (tipo == "familias_cadastradas") {
          this.$emit(
            "tipo",
            tipo,
            this.url + "img/icons/map/home-plus.svg",
            "Famílias Cadastradas com geolocalização"
          );
        } else if (tipo == "familias_acompanhamento") {
          this.$emit(
            "tipo",
            tipo,
            this.url + "img/icons/map/crowd.svg",
            "Famílias Acompanhamento"
          );
        } else if (tipo == "familias_atendidas") {
          this.$emit(
            "tipo",
            tipo,
            this.url + "img/icons/map/comment-eye.svg",
            "Famílias Atendidas"
          );
        } else if (tipo == "programas") {
          this.$emit(
            "tipo",
            tipo,
            this.url + "img/icons/map/charity.svg",
            "Programas Sociais"
          );
        } else if (tipo == "situacao_violacao") {
          this.$emit(
            "tipo",
            tipo,
            this.url + "img/icons/map/alert-decagram.svg",
            "Situação de Violação"
          );
        } else if (tipo == "vulnerabilidades") {
          this.$emit(
            "tipo",
            tipo,
            this.url + "img/icons/map/alert-circle.svg",
            "Vulnerabilidades"
          );
        } else if (tipo == "faixa_etaria") {
          this.$emit(
            "tipo",
            tipo,
            this.url + "img/icons/map/home-circle.svg",
            "Famílias por Faixa Etária"
          );
        } else if (tipo == "bi") {
          this.$emit(
            "tipo",
            tipo,
            this.url + "img/icons/map/home-circle.svg",
            "BI"
          );
        }
      },
    },
  };
</script>
